<template>
  <!-- pretraga samo recepata (naziv, kategorija, sastojci iz opisa); iznad stranica sa receptima -->
  <SiteSearch placement="inline"
              scope="recepti"
              placeholder="Pretraži recepte…"
              noun="recepata"
              label="Pretraga recepata: traži samo u receptima, po nazivu i kategoriji. Za pretragu celog sajta koristite polje na vrhu stranice."
              results-route="recepti-pretraga"
              results-path="/recepti-pretraga" />
</template>

<script setup>
import SiteSearch from '~/components/search/SiteSearch.vue'
</script>
